module.exports = __webpack_public_path__ + "static/media/close-button.5a1cea39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/icons/close-button.svg
// module id = 1972
// module chunks = 0